import firebase from "firebase/app";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/redux";
import { safeMap } from "src/util/functions";
import { validate } from "../../util/types";
import { tReduxAction } from "../types";

type tpFetchBrandLanding = (
  myBrandSnapshot: firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>,
) => tReduxAction;
export const fetchBrandLanding: tpFetchBrandLanding = (myBrandSnapshot) => (dispatch) => {
  if (myBrandSnapshot.empty) {
    dispatch({
      type: "ERROR",
      error: new Error("Brand Not Found"),
    });
    return;
  }

  const aBrandData = validate("tBrand")(myBrandSnapshot.docs[0].data());

  dispatch({
    type: "SET_BRAND_LANDING_DATA",
    brandData: aBrandData,
  });
};

type tpUseFetchBrandLanding = (myBrandName: string) => void;
export const useFetchBrandLanding: tpUseFetchBrandLanding = (myBrandName) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return firebase
      .firestore()
      .collection("brands")
      .where("name", "==", myBrandName)
      .onSnapshot((myBrandSnapshot) => {
        dispatch(fetchBrandLanding(myBrandSnapshot));
        dispatch({ type: "SET_LOADING_COMPANY", loading: false });
      });
  }, [dispatch, myBrandName]);
};

export const useFetchBrandLandingPromotions = (): void => {
  const dispatch = useAppDispatch();
  const aCompanyRefPath = useSelector(({ UserReducer }) => UserReducer.profile.companyRefPath);
  // const aAccountType = useSelector(({ UserReducer }) => UserReducer.profile.accountType);
  const rCompanyId = useSelector(({ BrandLandingReducer }) => BrandLandingReducer.brandData.id);

  useEffect(() => {
    if (!aCompanyRefPath) {
      dispatch({ type: "RESET_SETTINGS" });
      return undefined;
    }

    dispatch({
      type: "SET_LOADING_COMPANY",
      loading: true,
    });

    return firebase
      .firestore()
      .collection("promotions")
      .where("brandId", "==", rCompanyId)
      .where("isPrivate", "==", false)
      .where("deactivated", "==", false)
      .where("endDate", ">", Date.now())
      .onSnapshot((myCompanySnapshot) => {
        dispatch({ type: "SET_BRAND_PROMO_DATA", brandData: safeMap(myCompanySnapshot.docs, validate("tPromotion")) });
        dispatch({
          type: "SET_LOADING_COMPANY",
          loading: false,
        });
      });
  }, [aCompanyRefPath, rCompanyId, dispatch]);
};
